export default function classMapper<
  M extends { [key: string]: { [key: string]: string } }
>(map: M, props: { [key in keyof M]?: keyof M[key] | undefined | false }) {
  return Object.keys(props)
    .map((key) => {
      const value = props[key as keyof M];

      if (!value) return null;

      return map[key as keyof M][value as string];
    })
    .filter((item) => item);
}
